import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import * as actions from './actions'
import * as api from './api'
import * as selectors from './selectors'

export const fetchSavedRepliesEpic = (action$) => {
  return action$
    .ofType(actions.fetchSavedReplies.toString())
    .mergeMap(() => {
      return api.fetchReplies()
        .map((savedReplies) => {
          return actions.fetchSavedRepliesSuccess(savedReplies)
        })
        .startWith(actions.fetchSavedRepliesPending)
        .catch(error => Observable.of(actions.fetchSavedRepliesFailure(error)))
    })
}

export const updateSavedReplyEpic = (action$) => {
  return action$
    .ofType(actions.updateSavedReply.toString())
    .pluck('payload')
    .mergeMap(({ replyId, reply }) => {
      return api.updateReply(replyId, reply)
        .map(() => {
          return actions.updateSavedReplySuccess()
        })
        .startWith(actions.updateSavedReplyPending)
        .catch(error => Observable.of(actions.updateSavedReplyFailure(error)))
    })
}

export const setSavedReplyToComposerTextEpic = (action$, { getState }) => {
  return action$
    .ofType(actions.selectSavedReply.toString())
    .pluck('payload')
    .mergeMap(id => Observable.of(actions.setComposerTextToInsert(selectors.savedReplyToPopulate(id)(getState()))))
}

export const epic = combineEpics(
  fetchSavedRepliesEpic,
  updateSavedReplyEpic,
  setSavedReplyToComposerTextEpic,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/epic.js